import { API_USUARIO, HEADERS, ID_CUENTA } from "config/general/Configuracion";
import axios from "axios";

class ApiClient {
  constructor() {
    this.url = API_USUARIO;
  }

  listarUsuario = (paginacion) => {
    var query = "limite=" + encodeURIComponent(paginacion.limite);
    query += "&actual=" + encodeURIComponent(paginacion.actual);
    if (paginacion.filtro) {
      query += "&filtro=" + encodeURIComponent(paginacion.filtro);
    }
    if (paginacion.orden) {
      query += "&orden=" + encodeURIComponent(paginacion.orden);
    }
    if (paginacion.sentido) {
      query += "&sentido=" + encodeURIComponent(paginacion.sentido);
    }
    let respuesta = {
      method: "get",
      url: `${this.url}/v1/usuario/listado/${encodeURIComponent(
        sessionStorage[ID_CUENTA]
      )}?${query}`,
      headers: HEADERS(),
    };
    return respuesta;
  };


  puedeCrearPermisoAdministrador = () => this.puedeCrearPermiso("Administrador", sessionStorage.getItem("LIMITE_MAX_PERFILES_ADMINISTRADOR"));
  puedeCrearPermisoSupervisor = () => this.puedeCrearPermiso("Supervisor", "LIMITE_MAX_PERFILES_SUPERVISOR");
  puedeCrearPermisoAuxiliar = () => this.puedeCrearPermiso("Auxiliar", "LIMITE_MAX_PERFILES_AUXILIAR");
  puedeCrearPermisoMunicipio = () => this.puedeCrearPermiso("Municipio", "LIMITE_MAX_PERFILES_MUNICIPIO");
  puedeCrearPermisoVisor = () => this.puedeCrearPermiso("Visor", "LIMITE_MAX_PERFILES_VISOR");
  puedeCrearPermisoPromotor = () => this.puedeCrearPermiso("Promotor", "LIMITE_MAX_PERFILES_PROMOTOR");

  async puedeCrearPermiso(perfilNombre, limitePermitido) {
    const query = new URLSearchParams({
      limite: 100000,
      actual: 1,
      filtro: perfilNombre,
      orden: "p.nombre",
      sentido: "ASC",
    });
  
    try {
      const response = await axios({
        method: "get",
        url: `${this.url}/v1/usuario/listado/${encodeURIComponent(sessionStorage[ID_CUENTA])}?${query}`,
        headers: HEADERS(),
      });
  
      const totalActual = response?.data?.paginacion?.total || 0;
      return totalActual < Number(limitePermitido);
    } catch (error) {
      console.error(`Error al validar límite de ${perfilNombre}:`, error);
      return true; // Por seguridad, permite el perfil si falla la validación
    }
  }
  



  guardarUsuario = (usuario) => {
    let respuesta = {
      method: "post",
      url: `${this.url}/v1/usuario/usuario/${encodeURIComponent(
        sessionStorage[ID_CUENTA]
      )}`,
      headers: HEADERS(),
      data: usuario,
    };
    return respuesta;
  };

  listarPerfiles = () => {
    let respuesta = {
      method: "get",
      url: `${this.url}/v1/usuario/perfil/${encodeURIComponent(
        sessionStorage[ID_CUENTA]
      )}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

  listarDocumentos = () => {
    let respuesta = {
      method: "get",
      url: `${this.url}/v1/usuario/tipo-documento/${encodeURIComponent(
        sessionStorage[ID_CUENTA]
      )}`,
      headers: HEADERS(),
    };
    return respuesta;
  };
}
const UsuarioApi = new ApiClient();
export default UsuarioApi;
